import constants from "../../common/constants";
import SV_TRANSLATION from "./brands/default/messages/sv";
import EN_TRANSLATION from "./brands/default/messages/en";

export function extendTranslation(origin, extender) {
  if (origin.locale !== extender.locale) {
    throw Error("You are trying to extend different languages locales");
  }

  const { messages: originMessages, ...originRest } = origin;
  const { messages: extenderMessages, ...extenderRest } = extender;

  return {
    messages: {
      ...originMessages,
      ...extenderMessages
    },
    ...originRest,
    ...extenderRest
  };
}

export function addDefaultTranslation(brandSettings) {
  return {
    ...brandSettings,
    translation: {
      [constants.appLanguages.sv]: SV_TRANSLATION,
      [constants.appLanguages.en]: EN_TRANSLATION
    }
  };
}



// WEBPACK FOOTER //
// ./src/modules/brand/brand-utils.js